/**
 * ErpFloatingMenu
 * Menu de atalhos flutuante para dashboards de módulo (grid de navegação rápida).
 */

import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './ErpFloatingMenu.css'

function ErpFloatingMenu({
  title = 'Acesso Rápido',
  items = [],
  activePath,
  className = ''
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const currentPath = activePath ?? location.pathname

  if (!items.length) return null

  return (
    <section className={`erp-floating-menu ${className}`.trim()}>
      <h2 className="erp-floating-menu__title">{title}</h2>
      <div className="erp-floating-menu__grid">
        {items.map((item) => {
          const Icon = item.icon
          const isActive = currentPath === item.path

          return (
            <button
              key={item.path}
              type="button"
              className={`erp-floating-menu__item${isActive ? ' is-active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <span className={`erp-floating-menu__icon ${item.color || ''}`}>
                <Icon size={18} />
              </span>
              <span className="erp-floating-menu__label">{item.label}</span>
            </button>
          )
        })}
      </div>
    </section>
  )
}

export default ErpFloatingMenu
